import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { WorkFormContext } from '../work-form.types';
import { DepartmentDetailResponse } from '../../../../api';

export const useFormLocation = (
  defaultValues: Partial<WorkFormContext> | undefined,
  departmentData: DepartmentDetailResponse | undefined,
  setValue: UseFormSetValue<WorkFormContext>
) => {
  useEffect(() => {
    const isDepartmentDifferent = defaultValues?.department !== departmentData?.department.id;

    if (departmentData && isDepartmentDifferent) {
      setValue('location', departmentData.department.location, {
        shouldValidate: true,
      });
    }
  }, [departmentData?.department.id]);
};
